import { getFilebox } from '@/services/fileboxes.service';
import { redirectNotFound } from '@/utils/errorRedirect';

const Model = {
  namespace: 'fileboxDetails',
  state: {
    filebox: null,
  },

  effects: {
    *fetchFilebox({ payload }, { call, put }) {
      try {
        const response = yield call(getFilebox, payload.id);
        yield put({
          type: 'show',
          payload: { filebox: response.data },
        });
      } catch (error) {
        redirectNotFound(error);
      }
    },
  },

  reducers: {
    show(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};

export default Model;
